import { useEffect, useState } from "react";
import { useRequestFinished } from "../../../common/hooks";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import Form from "../../../common/form";
import CertificateDetailForm from "./CertificateDetailForm";
import { createRequest } from "../../../../store/slices/certificateSlice";
import { uploadRequest } from "../../../../store/slices/uploadSlice";

const CertificateDetails = ({
  labels,
  menu,
  uploadRequest,
  uploadDetails,
  action,
  requesting,
  error,
  createRequest,
}) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const [templateFilename, setTemplateFilename] = useState("");

  const onUpload = (event) => {
    const file = event.files[0];
    setTemplateFilename(file.name);
    uploadRequest({ file, type: "image" });
  };

  // Only a save answered while this screen is open: the persisted store can
  // still say "update" from an earlier save when the screen mounts (F-BUG-12).
  const requestFinished = useRequestFinished(requesting);
  useEffect(() => {
    if ((action === "create" || action === "update") && requestFinished && !error) {
      navigate(menu.to);
    }
  }, [error, action, requestFinished, menu, navigate]);

  const onSubmit = (values) => {
    const payload = {
      name: values.name,
      orientation: values.orientation,
      artifactId: uploadDetails?.[templateFilename]?.artifactId,
    };
    createRequest(payload);
  };

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "add_certificate" })}
          </div>
        </div>
        <div className="edexlms-page-body">
          <Form
            initialValues={{
              orientation: 1,
            }}
            submitBtn={{
              label: intl.formatMessage({
                id: "add_certificate",
              }),
              onClick: onSubmit,
            }}
            disabled={!uploadDetails?.[templateFilename]?.artifactId}
            cancelBtn={{
              label: intl.formatMessage({ id: "cancel" }),
              onClick: () => navigate(menu?.to),
            }}
          >
            <CertificateDetailForm
              uploadDetails={uploadDetails}
              templateFileName={templateFilename}
              onTemplateUpload={onUpload}
              onClear={() => setTemplateFilename("")}
            />
          </Form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  uploadDetails: state.uploads?.details,
  action: state.certificates?.action,
  requesting: state.certificates?.requesting,
  error: state.certificates?.error,
});

const mapDispatchToProps = (dispatch) => ({
  uploadRequest: (data) => dispatch(uploadRequest(data)),
  createRequest: (data) => dispatch(createRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificateDetails);
